<dt-modal-content (closeClick)="close()">
  <ng-template #title>
    @if (data.project) {
      <ng-container i18n>Projekt bearbeiten</ng-container>
    } @else {
      <ng-container i18n>Projekt hinzufügen</ng-container>
    }
  </ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      <mat-form-field>
        <mat-label i18n>Name</mat-label>
        <input matInput type="text" formControlName="name" />
      </mat-form-field>
      <mat-slide-toggle formControlName="visibility" i18n>Sichtbar für Benutzer</mat-slide-toggle>
      <dt-tag-input formControlName="tags" [allTags]="data.tags" i18n>Tags</dt-tag-input>
      <mat-form-field>
        <mat-label i18n>Link Token</mat-label>
        <input matInput type="text" formControlName="shareToken" />
        <mat-hint i18n>Ein benutzerdefinierter Token zur Verlinkung</mat-hint>
        @if (formGroup.controls.shareToken.errors?.['already-exists']) {
          <mat-error i18n>Dieser Link Token existiert bereits</mat-error>
        }
        @if (formGroup.controls.shareToken.errors?.['is-mongo-id']) {
          <mat-error i18n>Der Link Token darf keine Mongo ID sein</mat-error>
        }
      </mat-form-field>
      <div class="file-upload-container">
        <div>
          <ng-container i18n>Projektdaten:</ng-container>&nbsp;
          <span [class.red]="data.project == null && !formGroup.get('fileUpload').value">{{ fileState }}</span>
        </div>
        <div class="filler"></div>
        @if (formGroup.get('fileUpload').value) {
          <button mat-icon-button (click)="formGroup.get('fileUpload').setValue(null)" type="button"><mat-icon>clear</mat-icon></button>
        }
        <button mat-icon-button (click)="fileInput.click()" type="button"><mat-icon>file_upload</mat-icon></button>
      </div>
      <input #fileInput hidden type="file" accept=".json" formControlName="fileUpload" />

      @if (formGroup.hasError('invalid-project')) {
        <mat-error i18n>Die Projektdatei ist ungültig.</mat-error>
      }

      <div class="button-wrapper">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [dtOverlayProgress]="formGroup.disabled"
          [disabled]="formGroup.disabled || formGroup.invalid"
          i18n
          >Speichern</button
        >
        <button mat-stroked-button type="reset" [disabled]="formGroup.disabled" (click)="close()" i18n>Verwerfen</button>
        @if (data.project) {
          <button mat-stroked-button type="button" color="warn" [disabled]="formGroup.disabled" (click)="delete()" i18n
            >Projekt löschen</button
          >
        }
      </div>
    </form>
  </ng-template>
</dt-modal-content>
